import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICharge, ISearchStripeFailedChargesResponseData } from "../../api/charges/index.types";

interface ILatestFailedChargesState {
  data: {
    transactions: ICharge[];
  };
  loading: boolean;
}

const initialState: ILatestFailedChargesState = {
  data: {
    transactions: [],
  },
  loading: false,
};

const index = createSlice({
  name: "latestFailedCharges",
  initialState,
  reducers: {
    fetchRequest: (state) => {
      state.loading = true;
    },
    fetchSuccess: (state, action: PayloadAction<ISearchStripeFailedChargesResponseData>) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchFailed: (state) => {
      state.loading = false;
    },
  },
});

export const latestFailedChargesActions = index.actions;
export default index.reducer;
